// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import ElementUI from 'element-ui'
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import Qs from 'qs'
import promise from 'es6-promise';


//解决axios在ie浏览器下提示promise未定义的问题
promise.polyfill();

Vue.config.productionTip = false
Vue.prototype.$Axios=Axios;
Vue.prototype.$Qs=Qs;

Vue.use(ElementUI)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js